import styled from "styled-components"
import { Colors } from "../../../../../../../../../constant/Styled/Colors"
import { Title } from "../../../../../../../../../_webui/layout/components/Typography/Title"

const { BG_MARIANAS_WARNING, TEXT } = Colors

const StyledFlex = styled.div`
  margin-top: 10px;
`

const StyledFlexGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  column-gap: 20px;
`

const StyledFlexItem = styled.div<{ $colSpan?: number }>`
  --width-column: ${({ $colSpan = 1 }) => `calc(20% * ${$colSpan} - 20px)`};
  flex-basis: var(--width-column);
  max-width: var(--width-column);
  width: var(--width-column);
  > .ant-form-item {
    > .ant-form-item-row {
      > .ant-form-item-label {
        width: initial;
        height: initial;
        min-width: 100%;
        text-indent: initial;
        > label {
          justify-content: flex-start;
          height: initial;
          .form-label {
            flex-grow: initial;
          }
        }
      }
    }
  }
  .ant-form-item {
    margin-top: 0;
  }
`

const StyledTitle = styled(Title)`
  align-items: center;
  justify-content: flex-start;
`

const StyledTitleRight = styled.span`
  background-color: ${BG_MARIANAS_WARNING};
  border-radius: 4px;
  color: ${TEXT};
  display: inline-block;
  font-weight: 600;
  padding-left: 4px;
  padding-right: 4px;
`

export const Styled = {
  StyledFlex,
  StyledFlexGroup,
  StyledFlexItem,
  StyledTitle,
  StyledTitleRight,
}
